"use client";
import React, { useState, useEffect } from "react";
export default function Gallery() {
  const images = [
    "/icons/Gallery/PT1.png",
    "/icons/Gallery/PT2.png",
    "/icons/Gallery/PT3.png",
    "/icons/Gallery/PT4.png",
    "/icons/Gallery/1.png",
    "/icons/Gallery/2.png",
    "/icons/Gallery/3.png",
    "/icons/Gallery/5.png",
    "/icons/Gallery/6.png",
    "/icons/Gallery/7.png",
    "/icons/Gallery/8.png",
    "/icons/Gallery/4.png",
  ];
  const [currentSlide, setCurrentSlide] = useState(0);
  const imagesPerSlide = 4; // Số lượng hình ảnh trên mỗi slide

  // Function to go to the next slide
  const nextSlide = () => {
    setCurrentSlide((prev) =>
      prev === Math.ceil(images.length / imagesPerSlide) - 1 ? 0 : prev + 1
    );
  };

  // Function to go to the previous slide
  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? Math.ceil(images.length / imagesPerSlide) - 1 : prev - 1
    );
  };

  useEffect(() => {
    // Set interval to automatically go to the next slide every 3 seconds
    const interval = setInterval(() => {
      nextSlide();
    }, 10000); // 3000 milliseconds = 3 seconds

    // Clear the interval on component unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col items-center">
      <img className="mt-6" src="/icons/Gallery/tittle.png" />
      <div className="relative w-full max-w-[1240px] overflow-hidden mt-8">
        <div 
          className="flex transition-transform ease-in-out duration-500"
          style={{
            transform: `translateX(-${
              currentSlide * (300 / (images.length / imagesPerSlide))
            }%)`,
          }}
        >
          {Array.from({
            length: Math.ceil(images.length / imagesPerSlide),
          }).map((_, slideIndex) => (
            <div
              key={slideIndex}
              className="w-full flex-shrink-0 flex justify-between"
            >
              {images
                .slice(
                  slideIndex * imagesPerSlide,
                  slideIndex * imagesPerSlide + imagesPerSlide
                )
                .map((src, index) => (
                  <div key={index} className="w-1/4 px-1">
                    <img
                      src={src}
                      alt={`Slide ${slideIndex * imagesPerSlide + index + 1}`}
                      className="w-full h-auto"
                    />
                  </div>
                ))}
            </div>
          ))}
        </div>

        {/* Left Arrow */}
        <button
          onClick={prevSlide}
          className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-gray-800 text-white px-3 py-2 rounded-full"
        >
          ❮
        </button>

        {/* Right Arrow */}
        <button
          onClick={nextSlide}
          className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-gray-800 text-white px-3 py-2 rounded-full"
        >
          ❯
        </button>
      </div>

      {/* Dots Navigation */}
      <div className="flex justify-center mt-4">
        {Array.from({ length: Math.ceil(images.length / imagesPerSlide) }).map(
          (_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`h-3 w-3 mx-2 rounded-full ${
                currentSlide === index ? "bg-gray-800" : "bg-gray-400"
              }`}
            ></button>
          )
        )}
      </div>
    </div>
  );
}
